import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-guest-menu',
  templateUrl: './guest-menu.component.html',
  styleUrls: ['./guest-menu.component.scss']
})
export class GuestMenuComponent implements OnInit {
  @Output() public sidenavToggle = new EventEmitter();
  showSearch: boolean = false;

  constructor() {
  }

  ngOnInit() {

  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }

  public toggleSearch = () => {
    this.showSearch = !this.showSearch;
  }
}
